import api from '@/api/users';
import store from '@/store/store';

const loginUser = (context, credentials) => new Promise(((resolve, reject) => {
  api.loginUser(credentials)
    .then((response) => {
      resolve(response);
      store.commit('storeLoggedInUser', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const logoutUser = () => new Promise(((resolve, reject) => {
  api.logoutUser()
    .then((response) => {
      resolve(response);
      store.commit('removeLoggedInUser');
    })
    .catch((error) => {
      // eslint-disable-next-line
        store.commit('removeLoggedInUser');
      console.error(error);
      reject(error);
    });
}));

const resetPasswordToken = (context, userName) => new Promise(((resolve, reject) => {
  api.resetPasswordToken(userName)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const setPassword = (context, criteria) => new Promise(((resolve, reject) => {
  api.setPassword(criteria.token, criteria.password)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const registration = (context, criteria) => new Promise(((resolve, reject) => {
  api.registration(criteria.invitationCode, criteria.params, criteria.language)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchUser = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchUser(criteria.id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchWorkers = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchWorkers(criteria.partnerId, criteria.siteId, criteria.pageIndex, criteria.searchTerm, criteria.roles, criteria.orderInfo)
    .then((response) => {
      resolve(response);
      store.commit('users/storeUserList', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchWorker = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchWorker(criteria.partnerId, criteria.siteId, criteria.userId)
    .then((response) => {
      resolve(response);
      store.commit('users/storeUser', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const createWorker = (context, criteria) => new Promise(((resolve, reject) => {
  api.createWorker(criteria.partnerId, criteria.siteId, criteria.params)
    .then((response) => {
      resolve(response);
      store.commit('users/storeCreatedUser', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const updateWorker = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateWorker(criteria.partnerId, criteria.siteId, criteria.userId, criteria.params)
    .then((response) => {
      resolve(response);
      store.commit('users/storeUpdatedUser', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deleteWorker = (context, criteria) => new Promise(((resolve, reject) => {
  api.deleteWorker(criteria.partnerId, criteria.siteId, criteria.userId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchVivus = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchVivus(criteria.partnerId, criteria.pageIndex)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchNotifications = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchNotifications(criteria.id, criteria.pageIndex)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateNotifications = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateNotifications(criteria.id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const createUserAction = (context, criteria) => new Promise(((resolve, reject) => {
  api.createUserAction(criteria.id, criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchFeeds = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchFeeds(criteria.id, criteria.pageIndex)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchFeed = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchFeed(criteria.id, criteria.feedId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const createFeed = (context, criteria) => new Promise(((resolve, reject) => {
  api.createFeed(criteria.id, criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateFeed = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateFeed(criteria.id, criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const deleteFeed = (context, criteria) => new Promise(((resolve, reject) => {
  api.deleteFeed(criteria.id, criteria.feedId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchNotes = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchNotes(criteria.id, criteria.pageIndex, criteria.partnerId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchNote = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchNote(criteria.id, criteria.noteId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const createNote = (context, criteria) => new Promise(((resolve, reject) => {
  api.createNote(criteria.id, criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateNote = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateNote(criteria.id, criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const deleteNote = (context, criteria) => new Promise(((resolve, reject) => {
  api.deleteNote(criteria.id, criteria.noteId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchSpecs = () => new Promise(((resolve, reject) => {
  api.fetchSpecs()
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));
const changeUser = (context, id) => new Promise(((resolve, reject) => {
  api.changeUser(id)
    .then((response) => {
      resolve(response);
      store.commit('storePreviousUser', store.getters.loggedInUser);
      store.commit('storeLoggedInUser', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchPartnerAdmins = (ctx, criteria) => new Promise(((resolve, reject) => {
  api.fetchPartnerAdmins(criteria.pageIndex, criteria.orderInfo)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const createUser = (context, criteria) => new Promise(((resolve, reject) => {
  api.createUser(criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const updateUser = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateUser(criteria.userId, criteria.params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deleteUser = (context, criteria) => new Promise(((resolve, reject) => {
  api.deleteUser(criteria.userId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchAdmins = (ctx, criteria) => new Promise(((resolve, reject) => {
  api.fetchAdmins(criteria.pageIndex, criteria.orderInfo)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

export default {
  loginUser,
  logoutUser,
  resetPasswordToken,
  setPassword,
  registration,
  fetchWorkers,
  createWorker,
  updateWorker,
  deleteWorker,
  fetchWorker,
  fetchVivus,
  fetchNotifications,
  updateNotifications,
  createUserAction,
  fetchUser,
  fetchFeeds,
  fetchFeed,
  createFeed,
  updateFeed,
  deleteFeed,
  fetchNotes,
  fetchNote,
  createNote,
  updateNote,
  deleteNote,
  changeUser,
  fetchSpecs,
  fetchPartnerAdmins,
  createUser,
  updateUser,
  deleteUser,
  fetchAdmins,
};




// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js